import Confirm from '@/components/Confirm.vue'
import Dropdown from '@/components/Dropdown.vue'
import LoadingContent from '@/components/LoadingContent.vue'
import Autocomplete from '@/components/input/Autocomplete.vue'
import ContactAdd from '@/components/ContactAdd.vue'
import Datepicker from '@/components/input/Datepicker.vue'
import DateField from '@/components/input/DateField.vue'
import DateTimeField from '@/components/input/DateTimeField.vue'
import TimeField from '@/components/input/TimeField.vue'
import MonthMenu from '@/components/input/MonthMenu.vue'
import Event from '@/components/Event.vue'
import ObjectLink from '@/components/link/ObjectLink.vue'
import ClientLink from '@/components/link/ClientLink.vue'
import NoteForm from '@/components/NoteForm.vue'
import Heading from '@/components/Heading.vue'
import Card from '@/components/Card.vue'
import DashboardCard from '@/components/DashboardCard.vue'
import ListFilterChips from '@/components/ListFilterChips.vue'
import SignaturePad from '@/components/SignaturePad.vue'
import SignatureDialog from '@/components/SignatureDialog.vue'

export default function registerComponents (app) {
  app.component('Confirm', Confirm)
  app.component('Dropdown', Dropdown)
  app.component('LoadingContent', LoadingContent)
  app.component('Autocomplete', Autocomplete)
  app.component('ContactAdd', ContactAdd)
  app.component('Event', Event)
  app.component('ObjectLink', ObjectLink)
  app.component('ClientLink', ClientLink)
  app.component('NoteForm', NoteForm)
  app.component('Heading', Heading)
  app.component('Card', Card)
  app.component('DashboardCard', DashboardCard)
  app.component('ListFilterChips', ListFilterChips)
  app.component('Datepicker', Datepicker)
  app.component('DateField', DateField)
  app.component('DateTimeField', DateTimeField)
  app.component('TimeField', TimeField)
  app.component('MonthMenu', MonthMenu)
  app.component('SignaturePad', SignaturePad)
  app.component('SignatureDialog', SignatureDialog)
}
